import axios from 'axios';
import urlUtil from 'url';
import { parseString } from 'xml2js';
import { stripPrefix } from 'xml2js/lib/processors';
import { getCapabilitiesUrl } from './LayersUtils';
import { transformToProxyUrl, configProxyAxios } from '../utils/GeralUtils';

export const describeFeatureType = ({layer}) => {
    // axios.get(toDescribeURL(layer));
    //.let(interceptOGCError);
}

export const toLayerCapabilitiesURL = ({name, search = {}, url} = {}) => {
    const URL = getCapabilitiesUrl({name, url: search && search.url || url });
    const parsed = urlUtil.parse(URL, true);
    return urlUtil.format(
        {
            ...parsed,
            search: undefined, // this allows to merge parameters correctly
            query: {
                ...parsed.query,
                service: "WFS",
                version: "1.1.1",
                request: "GetCapabilities"
            }
        });
};
export const getLayerWFSCapabilities = async (layer) => {
    // console.log('toLayerCapabilitiesURL:', toLayerCapabilitiesURL(layer));
    return new Promise((resolve) => {
        const url = toLayerCapabilitiesURL(layer);
        resolve(axios.get(transformToProxyUrl(url), configProxyAxios(url)).then((response) => {
            let data;
            // interceptOGCError
            parseString(response.data, {
                tagNameProcessors: [stripPrefix],
                explicitArray: false,
                mergeAttrs: true
            }, (ignore, result) => {
                data = result;
            });
            return data;
        }));
    });
};


export default {
    describeFeatureType,
    getLayerWFSCapabilities
};